import { render, staticRenderFns } from "./assetView.vue?vue&type=template&id=f81d98aa&scoped=true"
import script from "./assetView.vue?vue&type=script&lang=js"
export * from "./assetView.vue?vue&type=script&lang=js"
import style0 from "./assetView.vue?vue&type=style&index=0&id=f81d98aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81d98aa",
  null
  
)

export default component.exports